import { Alert, Loader, Stack, Text } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { useThreeShapeOAuth } from "../../hooks/useThreeShapeOAuth";
import { notifications } from "@mantine/notifications";

export const ThreeShapeCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const state = searchParams.get("state");

  const {
    state: savedState,
    codeVerifier,
    regenerateThreeshapeTokens,
    resetFlow,
  } = useThreeShapeOAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      !code ||
      !state ||
      !codeVerifier ||
      !savedState ||
      state !== savedState
    ) {
      return;
    }

    void regenerateThreeshapeTokens({
      code,
      codeVerifier,
    })
      .then(() => {
        notifications.show({
          title: "Success",
          message: "3Shape tokens have been regenerated!",
          color: "green",
        });
      })
      .catch(err => {
        notifications.show({
          title: "Error",
          message: `Failed to regenerate 3Shape tokens: ${err.message}`,
          color: "red",
        });
      })
      .finally(() => {
        resetFlow();
        navigate("/settings");
      });
  }, [code, state, savedState, codeVerifier]);

  if (!code || !state || !codeVerifier || !savedState || state !== savedState) {
    return (
      <Alert
        variant="light"
        color="red"
        title="An error occured"
        icon={<IconInfoCircle />}
      >
        <Text>{"Token generation failed."}</Text>
      </Alert>
    );
  }

  return (
    <Stack align="center" justify="center" style={{ height: "100vh" }}>
      <Loader size="xl" variant="dots" />
      <Text>Generating token...</Text>
    </Stack>
  );
};
